define("preview-grid/routes/application", ["exports", "@ember/object", "@ember/routing/route", "@ember/service", "moment", "nprogress", "later/errors/invalid-credentials-error", "later/services/dialog-manager", "later/utils/promise-hash"], function (_exports, _object, _route, _service, _moment, _nprogress, _invalidCredentialsError, _dialogManager, _promiseHash) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12;
  0; //eaimeta@70e063a35619d71f0,"@ember/object",0,"@ember/routing/route",0,"@ember/service",0,"moment",0,"nprogress",0,"later/errors/invalid-credentials-error",0,"later/services/dialog-manager",0,"later/utils/promise-hash"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let ApplicationRoute = _exports.default = (_class = class ApplicationRoute extends _route.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "alerts", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "instagram", _descriptor4, this);
      _initializerDefineProperty(this, "router", _descriptor5, this);
      _initializerDefineProperty(this, "schedule", _descriptor6, this);
      _initializerDefineProperty(this, "segment", _descriptor7, this);
      _initializerDefineProperty(this, "errors", _descriptor8, this);
      _initializerDefineProperty(this, "store", _descriptor9, this);
      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor10, this);
      _initializerDefineProperty(this, "dialogManager", _descriptor11, this);
      _initializerDefineProperty(this, "credentialStatus", _descriptor12, this);
      _defineProperty(this, "postLimit", 60);
      _defineProperty(this, "errorList", []);
      _defineProperty(this, "fallbackProfile", null);
    }
    get currentAccount() {
      return this.auth.currentAccount;
    }
    get currentGroup() {
      return this.auth.currentGroup;
    }
    get currentUser() {
      return this.auth.currentUserModel;
    }
    get socialProfile() {
      return this.selectedSocialProfiles.firstProfile;
    }
    activate() {
      this.schedule.setSideLibraryBehavior('preview');
      if (this.socialProfile.get('isInstagram')) {
        this.segment.track('viewed-preview-grid', {
          ig_profile: '@' + this.socialProfile.get('nickname')
        });
      }
    }
    beforeModel() {
      if (this.socialProfile.needsRefresh) {
        this.alerts.warning(this.intl.t('alerts.errors.must_refresh_credentials.message', {
          feature: 'preview'
        }), {
          title: this.intl.t('shared_phrases.refresh_your_connection')
        });
        this.router.transitionTo('account.groups.group', this.currentGroup);
      } else if (!this.socialProfile.isInstagram) {
        this.alerts.warning(this.intl.t('alerts.preview_grid.non_ig.message', {
          feature: 'preview'
        }), {
          title: this.intl.t('alerts.preview_grid.non_ig.title')
        });
        this.router.transitionTo('account.groups.group.social_profiles', this.auth.currentGroup.id);
      } else if (this.currentAccount.stopTheWorldOrPastDue) {
        this.router.transitionTo('cluster.schedule');
      }
    }
    async model() {
      const maxNumOfPostsFromPagination = 8;
      if (!this.socialProfile.isInstagram) {
        throw new Error('Attempted to access preview with non-ig profile: ' + this.socialProfile.id);
      }
      this.fallbackProfile = this.socialProfile;
      this.schedule.updatePostLimit.perform();
      return (0, _promiseHash.default)({
        igPosts: this.instagram.fetchRecentMedia(this.socialProfile, {
          count: this.postLimit
        }).then(response => {
          if (!response?.pagination?.next) {
            return response?.posts;
          }
          return this.instagram.fetchRecentMedia(this.socialProfile, {
            count: this.postLimit
          }, response.pagination).then(responseWithPagination => [...response.posts, ...(responseWithPagination?.posts ?? []).slice(0, maxNumOfPostsFromPagination)]);
        }, error => {
          if (error.code === 429) {
            this.errorList.push('rateLimitError');
          } else if (error instanceof _invalidCredentialsError.default) {
            this.errorList.push(error);
          }
          this.errorList.push('igPostError');
          return [];
        }),
        posts: this.store.query('gram', {
          query_type: 'time',
          version_type: 'all',
          start_time: (0, _moment.default)().unix(),
          social_profile_id: this.socialProfile.id,
          limit: this.postLimit
        }).then(grams => grams, () => {
          this.errorList.push('scheduledPostError');
          return [];
        }),
        igUser: this.instagram.fetchSelf(this.socialProfile).catch(() => {
          this.errorList.push('igUserError');
          return {};
        })
      });
    }
    setupController(controller, model, transition) {
      super.setupController(controller, model, transition);
      const posts = this.store.peekAll('gram');
      const {
        postLimit,
        errorList,
        currentAccount
      } = this;
      controller.setProperties({
        igUser: model.igUser,
        igPosts: model.igPosts,
        socialProfile: this.socialProfile,
        posts,
        postLimit,
        errorList,
        currentAccount
      });
      if (this.errorList.find(error => error instanceof _invalidCredentialsError.default)) {
        this.alerts.alert(this.intl.t('alerts.errors.auto_publish.expired_token.message', {
          account_name: this.socialProfile.nickname
        }), {
          title: this.intl.t('shared_phrases.refresh_your_connection'),
          action: () => this.credentialStatus.showReconnectSocialProfileModal(this.socialProfile),
          actionText: this.intl.t('shared_words.refresh')
        });
      }
    }
    deactivate() {
      this.send('setSideLibraryBehavior', null);
    }
    error(error) {
      this.errors.log(error);
      this.alerts.warning(this.intl.t('alerts.preview_grid.loading_error.message'), {
        title: this.intl.t('alerts.preview_grid.loading_error.title'),
        action: () => this.router.transitionTo('cluster.schedule.calendar'),
        actionText: this.intl.t('alerts.preview_grid.loading_error.button_text')
      });
    }
    loading(transition) {
      const controller = this.controller;
      if (controller) {
        controller.reset();
      }
      transition.promise?.finally(() => {
        _nprogress.default.done();
      });
      return true;
    }
    addToPreview(mediaItemIds) {
      const controller = this.controller;
      controller.addNewPreviewPosts({
        mediaItemIds,
        fromQuickSchedule: true
      });
    }
    reloadRoute() {
      this.refresh();
    }
    willTransition(transition) {
      const controller = this.controller;
      if (controller.hasEditedPosts) {
        transition.abort();
        // Note: Although this aborts the transition - this will not safely handle situations where
        // other functionality accompanies the transition (for example, selectedSocialProfiles.addProfileAndTransition)
        this.dialogManager.confirm(this.intl.t('shared_phrases.close_warning'), {
          description: this.intl.t('preview_grid.confirm_unsaved'),
          confirmButton: this.intl.t('shared_words.leave')
        }).then(() => {
          controller.reset();
          transition.retry();
        }).catch(() => {
          // Note: If the dialog was prompted by selecting a new social profile, and the dialog was
          // then cancelled - we need to reset the selectedSocialProfiles to the original state and
          // prevent the transition from happening. We use selectExactly here as we do not want to trigger a
          // transition by using selectSingleProfile
          if (this.fallbackProfile) {
            this.selectedSocialProfiles.selectExactly([this.fallbackProfile]);
            this.dialogManager.rejectPromise(_dialogManager.DialogType.Confirmation);
          }
        });
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "instagram", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "schedule", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "credentialStatus", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "error", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "error"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loading", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "loading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addToPreview", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addToPreview"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reloadRoute", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "reloadRoute"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "willTransition", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "willTransition"), _class.prototype)), _class);
});